<template>
  <v-dialog v-model="dOpenAdminRoles" persistent width="800px">
    <!--Cabecera-->
    <v-card>
      <v-card-title class="data-bgPrimaryColor white--text data-headerModal">
        <div>
          <v-flex xs10 pl-2>
            <span class="data-title">{{ $t('rolDesc') }}</span>
          </v-flex>
          <v-flex xs2 class="iconClose">
            <v-btn class="close" flat icon color="white" @click="$emit('close')">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </div>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-3">
        <v-layout row wrap>
          <v-flex xs12 md6 px-3>
            <v-data-table :headers="dHeaders" :items="dItemsRoles" hide-actions>
              <template slot="items" slot-scope="props">
                <tr @click="fAbrirRol(props.item)">
                  <td class="text-xs-left ellipsis">
                    <span>{{ props.item.textRol }}</span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 md6 pa-3>
            <v-flex class="subsectionTabs py-2">{{ $t('fechas') }}</v-flex>
            <v-flex>
              <v-layout row wrap align-center>
                <v-flex xs12 sm10>
                  <v-flex xs12>
                    <v-text-field :value="dRolSeleccionado.textRol" :label="$t('tipoUser')" disabled
                      hide-details></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu :ref="dFechas.fechaIniMenu" lazy v-model="dFechas.fechaIniMenu"
                      transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px">
                      <v-text-field clearable color="data-colorcorp1" slot="activator" :label="$t('fechaInicial')"
                        v-model="dFechas.fechaIniString" append-icon="event" readonly hide-details></v-text-field>
                      <v-date-picker clearable v-model="dFechas.fechaIni" no-title scrollable :first-day-of-week="1"
                        locale="es-es" @input="fGetFecha(dFechas.fechaIni, 'ini')"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu :ref="dFechas.fechaFinalMenu" lazy v-model="dFechas.fechaFinalMenu"
                      transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px">
                      <v-text-field clearable color="data-colorcorp1" slot="activator" :label="$t('fechaFinal')"
                        v-model="dFechas.fechaFinalString" append-icon="event" readonly hide-details></v-text-field>
                      <v-date-picker clearable v-model="dFechas.fechaFinal" no-title scrollable :first-day-of-week="1"
                        locale="es-es" @input="fGetFecha(dFechas.fechaFinal, 'final')"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field color="data-colorcorp1" slot="activator" :label="$t('diasAntiguedad')"
                      v-model="dFechas.diasAntiguedad" hide-details>
                      <template slot="append">
                        <v-tooltip bottom>
                          <v-icon slot="activator">mdi-information</v-icon>
                          <span>
                            <p class="pt-1 mb-0">{{ $t('diasAntiguedadDesc') }}</p>
                          </span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch v-model="dFechas.autoFiltro" :label="$t('activarFiltro')">
                      <template slot="append">
                        <v-tooltip bottom>
                          <v-icon slot="activator">mdi-information</v-icon>
                          <span>
                            <p class="pt-1 mb-0">{{ $t('activarFiltroDesc') }}</p>
                          </span>
                        </v-tooltip>
                      </template>
                    </v-switch>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-flex xs12 text-xs-right>
          <v-btn class="datPrimaryBtn" flat @click="fActualizaRoles()">{{ $t('aceptar') }}</v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SrvFechasRoles from '@/services/srv-fechas-roles'
export default {
  props: {
    dOpenAdminRoles: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  data() {
    return {
      dNewConfigure: false,
      dHeight: 'calc(100vh - 300px)',
      dItemsRoles: null,
      dAddFiltro: false,
      dHeaders: [
        { text: this.$t('rolTable'), value: 'textRol', sortable: true }
      ],
      dFechas: {
        'fechaIni': '',
        'fechaIniString': '',
        'fechaIniMenu': null,
        'fechaFinal': '',
        'fechaFinalString': '',
        'fechaFinalMenu': null,
        'diasAntiguedad': '',
        'autoFiltro': false
      },
      dRolSeleccionado: {
        'idRol': 0,
        'textRol': '',
        'rol': ''
      },
      eventoMostrar: 'evento-mostrarAvisos'

    }
  },
  created() {
    this.fGetRoles()
  },
  methods: {
    fGetRoles() {
      this.dItemsRoles = []
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion
      }
      SrvFechasRoles.getRoles(payload).then(response => {
        if (response.data.statusCode === '200') {
          const roles = response.data.result
          roles.map((role, index) => {
            this.dItemsRoles.push({ 'textRol': this.$t(role.descripcion), 'idRol': role.idRol })
          })
        } else {
          if (response.data.statusText !== undefined) {
            this.$bus.$emit(this.eventoMostrar, '<b>carga roles</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
          }
          if (response.data.exception !== undefined) {
            this.$bus.$emit(this.eventoMostrar, '<b>carga roles</b><br> ' + response.data.exception)
          }
        }
      })
    },
    fAbrirRol(rol) {
      this.dRolSeleccionado = rol
      this.dFechas.fechaIniString = ''
      this.dFechas.fechaFinalString = ''
      this.dFechas.diasAntiguedad = ''
      this.dFechas.autoFiltro = false
      const payload = {
        organizacion:this.$store.getters.getAutenticacion.empresa,
        rol: rol.idRol
      }
      SrvFechasRoles.getFechasRoles(payload).then(response => {
        const roles = response.data.roles
        if (roles.length > 0) {
          let fechaInicial, fechaFinal, diasAntiguedad, autoFiltro
          roles.forEach(element => {
            fechaInicial = element.fechaInicio
            fechaFinal = element.fechaFinal
            diasAntiguedad = element.diasAntiguedad
            autoFiltro = element.autoFiltro
          })
          this.dNewConfigure = false
          this.dFechas.fechaIniString = this.fGetDateFormatter(fechaInicial)
          this.dFechas.fechaFinalString = this.fGetDateFormatter(fechaFinal)
          this.dFechas.diasAntiguedad = diasAntiguedad
          if (autoFiltro === null || autoFiltro === '' || autoFiltro === 'N') {
            this.dFechas.autoFiltro = false
          } else if (autoFiltro === 'S') {
            this.dFechas.autoFiltro = true
          }
        } else {
          this.dNewConfigure = true
        }
      })
    },
    fGetFecha(val, tipo) {
      switch (tipo) {
        case 'ini':
          this.dFechas.fechaIniString = this.fGetDateFormatter(val)
          break
        case 'final':
          this.dFechas.fechaFinalString = this.fGetDateFormatter(val)
          break
      }
    },
    fGetDateFormatter(value) {
      return (value !== '') ? this.$moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
    },
    fActualizaRoles() {
      if (this.dRolSeleccionado !== null) {
        const payload = {
          'empresa': this.$store.getters.getAutenticacion.empresa,
          'idRol': this.dRolSeleccionado.idRol,
          'fechaInicial': this.dFechas.fechaIniString,
          'fechaFinal': this.dFechas.fechaFinalString,
          'diasAntiguedad': parseInt(this.dFechas.diasAntiguedad),
          'autoFiltro': (this.dFechas.autoFiltro) ? 'S' : 'N'
        }
        SrvFechasRoles.actualizarRoles(payload).then(response => {
          if (response.data.statusCode === '200') {
            switch (response.data.code) {
              /*
               * Significado de los codes
               * 1.- Inserta las fechas, crea una nueva fila.
               * 2.- Se actualiza la fila
               * -1.- Ya existe dicha fila y ha intentado insertarla en vez de actualizarla
               */
              case 1:
                this.$bus.$emit(this.eventoMostrar, '<b>' + this.$t('insercionRoles') + '</b><br>' + this.$t('insercionRolesDesc'))
                break
              case 2:
                this.$bus.$emit(this.eventoMostrar, '<b>' + this.$t('insercionRoles') + '</b><br>' + this.$t('insercionRolesDescAct'))
                break
              case -1:
                this.$bus.$emit(this.eventoMostrar, '<b>' + this.$t('errorRoles') + '</b><br>' + this.$t('errorRolesDesc'))
                break
            }
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Administracion/ShpAdministracionRoles.vue